import { render } from "./LeadDialogUploads.vue?vue&type=template&id=2f048cec&scoped=true"
import script from "./LeadDialogUploads.vue?vue&type=script&lang=js"
export * from "./LeadDialogUploads.vue?vue&type=script&lang=js"

import "./LeadDialogUploads.vue?vue&type=style&index=0&id=2f048cec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f048cec"]])

export default __exports__